// Componente para gestionar la capacidad de zonas y mostrar alertas

<template>
  <div class="capacity-management">
    <!-- Indicador visual de capacidad -->
    <div class="capacity-indicator mb-3">
      <div class="progress" style="height: 20px;">
        <div 
          class="progress-bar" 
          :class="capacityBarClass" 
          role="progressbar" 
          :style="`width: ${usagePercentage}%`" 
          :aria-valuenow="usagePercentage" 
          aria-valuemin="0" 
          aria-valuemax="100">
          {{ usagePercentage }}%
        </div>
      </div>
      <small class="d-block mt-1">
        {{ currentUsage }} de {{ capacity }} unidades utilizadas
      </small>
    </div>
    
    <!-- Alertas de capacidad -->
    <div v-if="showAlert" class="capacity-alert alert" :class="alertClass" role="alert">
      <i :class="alertIcon" class="me-2"></i>
      {{ alertMessage }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZoneCapacityManager',
  props: {
    capacity: {
      type: Number,
      required: true,
      default: 100
    },
    currentUsage: {
      type: Number,
      required: true,
      default: 0
    },
    showAlerts: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    usagePercentage() {
      if (this.capacity === 0) return 100;
      return Math.min(Math.round((this.currentUsage * 100) / this.capacity), 100);
    },
    isOverCapacity() {
      return this.currentUsage > this.capacity;
    },
    isNearCapacity() {
      return this.usagePercentage >= 90 && !this.isOverCapacity;
    },
    capacityBarClass() {
      if (this.isOverCapacity) return 'bg-danger';
      if (this.isNearCapacity) return 'bg-warning';
      return 'bg-success';
    },
    showAlert() {
      return this.showAlerts && (this.isOverCapacity || this.isNearCapacity);
    },
    alertClass() {
      return this.isOverCapacity ? 'alert-danger' : 'alert-warning';
    },
    alertIcon() {
      return this.isOverCapacity ? 'bi bi-exclamation-triangle-fill' : 'bi bi-exclamation-circle-fill';
    },
    alertMessage() {
      if (this.isOverCapacity) {
        return 'Capacidad de la zona completa. Debe buscar otra zona para dejar sus productos.';
      }
      return 'La capacidad de la zona está a un 90%. Considere utilizar otra zona para nuevos ingresos.';
    }
  },
  methods: {
    // Método para verificar si hay capacidad disponible para una cantidad específica
    hasAvailableCapacity(quantity) {
      return (this.currentUsage + quantity) <= this.capacity;
    },
    
    // Método para emitir eventos cuando cambia el estado de capacidad
    emitCapacityStatus() {
      this.$emit('capacity-status', {
        percentage: this.usagePercentage,
        isOverCapacity: this.isOverCapacity,
        isNearCapacity: this.isNearCapacity,
        hasCapacity: !this.isOverCapacity
      });
    }
  },
  watch: {
    currentUsage() {
      this.emitCapacityStatus();
    },
    capacity() {
      this.emitCapacityStatus();
    }
  },
  mounted() {
    this.emitCapacityStatus();
  }
}
</script>

<style scoped>
.capacity-management {
  margin-bottom: 1rem;
}

.capacity-indicator {
  margin-top: 0.5rem;
}

.capacity-alert {
  font-weight: 500;
}
</style>
